export const iconTitle = 'עבריתה';
export const aboutLinkText = 'אודות מיזם עבריתה';
export const defaultMaleLabel = 'איש';
export const defaultFemaleLabel = 'אישה';
export const defaultNeutralLabel = 'ניטרלי';
